import { render, staticRenderFns } from "./TasteNotesInput.vue?vue&type=template&id=111a2ea2"
import script from "./TasteNotesInput.vue?vue&type=script&lang=js"
export * from "./TasteNotesInput.vue?vue&type=script&lang=js"
import style0 from "./TasteNotesInput.vue?vue&type=style&index=0&id=111a2ea2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports